<template>
  <div class="full-wrapper">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <component :is="currentView" :active="active" />
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { treeNodeSubType } from '@/constants/tree';
import WConfigApmNode from './apm';
import WConfigServerNode from './server';
import WConfigNetDeviceNode from './netdevice';
import WConfigNetInterfaceNode from './netinterface';
import WConfigDatabaseNode from './database';
import WConfigSensorNode from './sensor';
import WConfigE2eNode from './e2e';
import WConfigServiceeNode from './service';
import WConfigVirtualNode from './virtual';
import WConfigApControllerNode from './ap-controller';
import WConfigWirelessApNode from './wireless-ap';

export default {
  name: 'WConfigNode',
  mixins: [ScrollbarMixin],
  components: {
    WConfigApmNode,
    WConfigServerNode,
    WConfigNetDeviceNode,
    WConfigNetInterfaceNode,
    WConfigDatabaseNode,
    WConfigSensorNode,
    WConfigE2eNode,
    WConfigServiceeNode,
    WConfigVirtualNode,
    WConfigApControllerNode,
    WConfigWirelessApNode,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (this.currentView === null || to.treeKey !== from.treeKey) {
          // TODO: 트리 타입마다 treeKey가 같아도 다른 노드일 수 있음. 해당 부분 처리 추가 필요함.
          this.changeView();
        }
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    /**
     * 선택된 노드에 맞는 장비 구성 정보 화면을 설정한다.
     * @author Ju
     * @return {[type]} [description]
     */
    changeView() {
      if (this.selectedNode.subType === treeNodeSubType.SERVER) {
        this.currentView = WConfigServerNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.NETDEVICE) {
        this.currentView = WConfigNetDeviceNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.NETINTERFACE) {
        this.currentView = WConfigNetInterfaceNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.DBMS) {
        this.currentView = WConfigDatabaseNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.SENSOR) {
        this.currentView = WConfigSensorNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.E2E) {
        this.currentView = WConfigE2eNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.SERVICE) {
        this.currentView = WConfigServiceeNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.VIRTUAL) {
        this.currentView = WConfigVirtualNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.APM) {
        this.currentView = WConfigApmNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.AP_CONTROLLER) {
        this.currentView = WConfigApControllerNode.name;
      } else if (this.selectedNode.subType === treeNodeSubType.WIRELESS_AP) {
        this.currentView = WConfigWirelessApNode.name;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/index.vue